import * as React from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {Option} from "ts-option";
import SelectLeadType from "../leadType/SelectLeadType";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

type Props = FormGroupProps<string> & PlaceholderProps;

/**
 * Lead type form view group.
 */
export default class LeadTypeGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectLeadType placeholder={this.props.placeholder}
								selectedId={this.props.field.getOptionalValue()}
								onChanged={this.onChange}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed lead type.
	 * @param data
	 */
	onChange(data: Option<DictionaryItem>) {
		this.props.onChange(this.props.field.updateValue(data.map((ac) => ac.id)))
	}
}
